export const subscriptionsURLs = {
  getSubscriptionPackages: 'subscription-packages',
  getSubscriptionGroups: 'subscription-groups',
  getClientSubscriptions: 'client-subscriptions',
}

export const clientAccountsURLs = {
  getClientAccounts: 'client-accounts',
  getClientConfig: 'client-config',
  getSignUp: 'sign-up',
  getProfile: 'profile',
  getUsers: 'users',
  getUsersEmailConfirm: 'users-email-confirm',
  getUsersValidationEmailResend: 'users-validation-email-resend',
  getUsersPasswordReset: 'users-password-reset',
  getUsersPasswordResetConfirm: 'users-password-reset-confirm',
  getUsersPasswordUpdate: 'users-password-update',
  getBalanceRefill: 'balance-refill',
}

export const serviceConfigsURLs = {
  getSupportedServiceConfigs: 'supported-service-configs',
  getClientServiceConfigs: 'client-service-configs',
  getClientServiceDnsResolver: 'client-service-dns-resolver',
  getClientCertificateConfigs: 'client-certificate-configs',
}

export const supportedPaymentsURLs = {
  getSupportedPaymentMethods: 'supported-payment-methods',
}

export const billingAccountConfigsURLs = {
  getAccountConfigs: 'account-configs',
  getAccountPaymentMethod: 'account-payment-method',
}

export const billingAccountServicesURLs = {
  getAccountServices: 'account-services',
}

export const fileManagerURLs = {
  getUploadUiLogo: 'upload-ui-logo',
  getUploadUiBg: 'upload-ui-bg',
  getUploadUiDoc: 'upload-ui-doc',
  getDeleteFile: 'delete-file',
}

export const alertsURLs = {
  getAlertsEmailSettings: 'alerts-email-settings',
  getAlerts: 'alerts',
}

export const billingServiceURLs = {
  billingConfigsEP: "account-configs",
  billingServicesEP: "account-services",
  billingPricesEP: "account-prices",
  billingDepositsEP: "project-deposits",
  billingSupportedServicesEP: "supported-billing-services",
  billingSupportedResourcesEP: "supported-billing-resources",
  billingServiceBreakdownEP: "services-month-breakdown",
  billingTopNProjectsEP: "top-n-projects",
  billingIncomeSummaryEP: "income-summary",
  billingIncomeCompareEP: "income-compare",
  billingResourceUsageSummaryEP: "resource-usage-summary",
  billingResourceUsageCompareEP: "resource-usage-compare",
  billingServiceChargesEP: "service-charges",
  billingPaymentsEP: "deposit-refill",
  billingInvoicesEP: "postpaid-invoices",
  billingAccountProjectsEP: "account-projects",
}

export const docsURLs = {
  getDocsCatalog: 'docs-catalog',
  getDocs: 'docs',
}

export const externalAppsURLs = {
  getExternalApps: 'external-apps',
}